import React, { Component } from "react";
import { Button, Table, Form, Input, Divider, message, DatePicker } from "antd";
import axios from "../../service/index";
const { RangePicker } = DatePicker;
class Administrators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        name: "",
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (a) => {
          let pagination = this.state.pagination;
          pagination.current = a;
          this.setState({ pagination }, this.getTable);
        },
      },
      dateRange: [],
      getAdminListData: [],
      nodata: "无数据",
      searchData: {
        startTime: "",
        endTime: "",
        userName: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      columns: [
        {
          title: "操作模块",
          dataIndex: "module",
          key: "module",
          align: "center",
        },
        {
          title: "操作按钮",
          dataIndex: "btnName",
          key: "btnName",
          align: "center",
        },
        {
          title: "请求URL",
          dataIndex: "reqUrl",
          key: "reqUrl",
          align: "center",
        },
        {
          title: "操作人员",
          dataIndex: "operUserName",
          key: "operUserName",
          align: "center",
        },
        {
          title: "操作时间",
          dataIndex: "operTime",
          key: "operTime",
          align: "center",
        },
      ],
    };
  }
  componentDidMount() {
    this.getAdminList();
  }

  getAdminList = (page) => {
    if (page) {
      this.setState({ searchData: page });
    }
    axios
      .post("admin/queryOperLogs", {
        ...this.state.searchData,
        userName: this.state.userName,
        startTime: this.state.dateRange[0],
        endTime: this.state.dateRange[1],
      })
      .then((res) => {
        if (res.data.code === "200") {
          this.setState({
            getAdminListData: res.data.data.list,
            searchData: {
              total: res.data.data.total,
              // pageSize: res.data.data.pageSize,
              pageNum: res.data.data.pageNum,
            },
          });
        } else {
          message.error(res.data.msg);
        }
      });
  };
  delAdmin(id) {
    axios.get(`admin/del/${id}`).then((res) => {
      if (res.data.code === "200") {
        message.success("删除成功");
        this.getAdminList();
      } else {
        message.error(res.data.msg);
      }
    });
  }

  render() {
    const { getAdminListData, columns, searchData } = this.state;
    const pagination = {
      showSizeChanger: true,
      total: searchData.total,
      pageSizeOptions: ["10", "20", "30", "40"],
      showTotal: () => `共 ${searchData.total} 条`,
      onShowSizeChange: (current, pageSize) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        searchData.pageSize = pageSize;
        this.getAdminList(searchData);
      },
      onChange: (current, pageSize) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        searchData.pageSize = pageSize;
        this.getAdminList(searchData);
      },
    };
    return (
      <div>
        <span style={{ display: "flex", alignItems: "center", fontSize: "18px", fontWeight: "600" }}>操作记录</span>
        <Divider />
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
          <div>
            <span style={{ marginRight: "10px" }}>操作人员</span>
            <Input
              allowClear={true}
              value={this.state.userName}
              style={{ width: "260px", height: "40px", marginRight: "20px" }}
              placeholder="请输入操作人员"
              onChange={(e) => {
                this.setState({
                  userName: e.target.value,
                });
              }}></Input>
            <span style={{ marginRight: "10px" }}>时间</span>
            <RangePicker
              size={"large"}
              onChange={(date, dateString) => {
                this.setState({
                  dateRange: dateString,
                });
              }}
            />
            <Button
              style={{ marginLeft: "20px" }}
              className="my-button-primary"
              type="primary"
              onClick={() => {
                this.getAdminList();
              }}>
              查询
            </Button>
            <span
              className="my-button-txt"
              style={{ marginLeft: "20px" }}
              onClick={() => {
                this.setState(
                  {
                    userName: "",
                  },
                  () => {
                    this.getAdminList();
                  }
                );
              }}>
              重置
            </span>
          </div>
        </div>
        <Table
          dataSource={getAdminListData}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={pagination}
          rowClassName={(record, index) => (index % 2 !== 0 ? "table-line" : "")}
        />
      </div>
    );
  }
}

export default Form.create()(Administrators);
